import {
  Typography,
  Button,
  Link,
  Form,
  TextField,
  useEmailAddressValidator,
  Box,
} from '@ace-clublabs/shared-component-library';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Pages } from '../shared/pages';
import { useGlobalState } from '../shared/state';
import { Header } from './Header';
import { UtagHelper, UtagParam } from '../utils/utagHelper';
import { PolicyType } from '../shared/types';
import { ProductType } from '@ace-clublabs/payment-types';

const UpdateEmail = () => {
  const navigate = useNavigate();
  const [transactionId, setTransactionId] = useState('');
  const [, setEmailFromWeb] = useGlobalState('emailFromWeb');
  const [billPlan] = useGlobalState('billPlan');
  const [sessionId] = useGlobalState('sessionId');
  const [clubCode] = useGlobalState('clubCode');
  const [selectedProduct] = useGlobalState('selectedProduct');

  const productType =
    selectedProduct.policyType === PolicyType.Membership ? ProductType.Membership : ProductType.Insurance;

  const tag = () => {
    const tags = {
      ...UtagHelper.CommonTaggingValues,
      clubcode: clubCode,
      page: UtagHelper.Pages.noEmailOnFile,
      sessionid: sessionId,
      mem_billplan: billPlan,
      flow: productType === ProductType.Membership ? 'membership' : 'insurance',
    } as UtagParam;
    UtagHelper.tag(tags);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const transactionId = urlParams.get('transactionId')!;
    setTransactionId(transactionId);
  }, []);

  useEffect(() => {
    tag();
  }, []);

  const handleContinue = (form: { [key: string]: string }) => {
    const email = form.email;
    if (email) {
      setEmailFromWeb(email);
    }
    navigate(`${Pages.Confirmation}?transactionId=${transactionId}`);
  };

  return <UpdateEmailView handleContinue={handleContinue} />;
};

interface UpdateEmailViewProps {
  handleContinue: (e: any) => void;
}

const UpdateEmailView = ({ handleContinue }: UpdateEmailViewProps) => {
  const [email, setEmail] = useState('');
  const handleLinkClick = (url: string) => (event: any) => {
    event.preventDefault();
    window.open(url);
  };

  const regex = '(^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$)';

  const getContinueButtonEnabled = () => {
    const emailValid = new RegExp(regex).test(email);
    return emailValid;
  };

  return (
    <Box id="update-email-container" className="container">
      <Header />
      <Typography variant="h5" sx={{ fontWeight: '500' }} component="h1">
        Enter an email address where we can send you a confirmation
      </Typography>
      <Form onSubmit={handleContinue}>
        <TextField
          id="email-input"
          label="Email address"
          className="email-input"
          fullWidth
          onChange={(e: any) => setEmail(e.target.value)}
          validator={useEmailAddressValidator({ label: 'Email address', required: true })}
        />
        <Button
          id="emails-continue"
          fullWidth={true}
          variant="contained"
          onClick={() => handleContinue({ email })}
          disabled={!getContinueButtonEnabled()}
          label="Continue"
          sx={{ marginBottom: '12px', fontColor: 'white' }}
        ></Button>
      </Form>

      <Typography variant="b2Regular" className="third-party-info">
        I agree to calls and texts, using automated technology, from or on AAA&apos;s behalf regarding membership
        products/services and offers. Consent is not a condition of purchase. Message and data rates may apply. I agree
        to the{' '}
        <Link variant="b2Regular" component="a" onClick={handleLinkClick('https://www.ace.aaa.com/legal/privacy.html')}>
          Privacy Policy
        </Link>
        ,{' '}
        <Link
          variant="b2Regular"
          component="a"
          onClick={handleLinkClick('https://www.ace.aaa.com/legal/terms-of-use.html')}
        >
          Terms &amp; Conditions
        </Link>
        , and{' '}
        <Link
          variant="b2Regular"
          component="a"
          onClick={handleLinkClick('https://www.ace.aaa.com/legal/text-messaging-programs-terms-and-conditions.html')}
        >
          Text Terms
        </Link>
        .
      </Typography>
    </Box>
  );
};

export { UpdateEmail, UpdateEmailView };
